import axios from "@/api/axiosInstance";

export const reactivateUser = async (employeeUuid: string): Promise<void> => {
  await axios.post(`/api/private/admin/employees/${employeeUuid}/reactivate`);
};
